/**
 * Custom Bar Path Component
 *
 * A custom SVG bar shape with rounded corners only on the right side.
 * Used in the HorizontalBarChart component.
 */

import React from 'react';

export interface CustomBarPathProps {
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    fill?: string;
}

export const CustomBarPath: React.FC<CustomBarPathProps> = ({ x, y, width, height, fill }) => {
    if (x === undefined || y === undefined || width === undefined || height === undefined) {
        return null;
    }

    const radius = 8;

    // Create a path with rounded corners only on the right side
    const path = `
        M ${x},${y}
        L ${x + width - radius},${y}
        Q ${x + width},${y} ${x + width},${y + radius}
        L ${x + width},${y + height - radius}
        Q ${x + width},${y + height} ${x + width - radius},${y + height}
        L ${x},${y + height}
        Z
    `;

    return (
        <path
            d={path}
            fill={fill}
        />
    );
};
